function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { styled } from "../styles";
const Layout = styled(Stack, {
  shouldForwardProp: prop => prop !== 'variant'
})(_ref => {
  let {
    theme,
    variant
  } = _ref;
  return {
    backgroundColor: "transparent",
    justifyContent: "flex-start",
    marginLeft: theme.spacing(-3),
    marginTop: theme.spacing(-1),
    flexWrap: "wrap",
    ...(variant === "vertical" && {
      "& > div": {
        margin: theme.spacing(0.5, 3),
        marginTop: theme.spacing(1)
      },
      "& > hr": {
        marginTop: theme.spacing(1)
      }
    })
  };
});
const LabelValueLayout = _ref2 => {
  let {
    children,
    variant = 'vertical',
    divider = true,
    ...restProps
  } = _ref2;
  const sx = variant === 'horizontal' ? {
    margin: 0,
    flexDirection: "column",
    flexWrap: "nowrap",
    width: "100%",
    minWidth: "360px"
  } : {};
  const direction = variant === 'horizontal' ? 'column' : 'row';
  return /*#__PURE__*/React.createElement(Layout, _extends({
    variant: variant,
    direction: {
      xs: "column",
      sm: direction,
      md: direction
    },
    divider: divider && /*#__PURE__*/React.createElement(Divider, {
      orientation: variant,
      flexItem: true
    }),
    sx: sx
  }, restProps), React.Children.map(children, child => /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
    ...child.props,
    variant: variant
  }) : child));
};
export default LabelValueLayout;